import CryptoJS from 'crypto-js';

const AES_SECRET = process.env.REACT_APP_AES_SECRET || 'SisTeP4ctoZwUi25';

export const encryptAES = (data) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(AES_SECRET.substring(0, 16));
    
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return encrypted.toString();
  } catch (error) {
    console.error('Erro ao criptografar dados:', error);
    throw new Error('Falha na criptografia dos dados');
  }
};

export const decryptAES = (encryptedData) => {
  try {
    const key = CryptoJS.enc.Utf8.parse(AES_SECRET.substring(0, 16));
    
    const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    
    if (!decryptedText) {
      throw new Error('Dados descriptografados estão vazios');
    }
    
    return decryptedText;
  } catch (error) {
    console.error('Erro ao descriptografar dados:', error);
    throw new Error('Falha na descriptografia dos dados');
  }
};

export const encryptObject = (obj) => {
  const jsonString = JSON.stringify(obj);
  return encryptAES(jsonString);
};

export const decryptObject = (encryptedData) => {
  const decryptedString = decryptAES(encryptedData);
  return JSON.parse(decryptedString);
};

